import { createForm } from '../../../factories'

export default createForm(['email', 'token'])



// WEBPACK FOOTER //
// ./src/store/modules/register/forms/confirmEmail.js